/** Top-level S3 library folders shown at root (case-insensitive match). */
export const LIBRARY_ROOT_FOLDERS = ["NDA", "CDS"];

export const isLibraryRootFolder = (name) => {
  if (!name) return false;
  const upper = String(name).trim().toUpperCase();
  return LIBRARY_ROOT_FOLDERS.some((root) => root.toUpperCase() === upper);
};

export const normalizeFolderPathNames = (pathNames = []) =>
  (Array.isArray(pathNames) ? pathNames : []).map((part) => String(part).trim()).filter(Boolean);
